import { withRouter } from 'react-router-dom';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Switch,
} from '@mui/material';
import { Button } from 'global/components/Button';
import { useTaskTypes } from './useTaskTypes';
import { useScreen } from 'global/styles';
import {
  DisabledRow,
  DisabledTextCell,
  EnabledRow,
  HeaderCell,
  TaskTypeContainer,
} from './styles';
import { get } from 'global/lib/lodash';
import { uppercaseFirst } from 'global/utils';
import { CenterLoader } from 'global/styles';

const COLUMNS = [
  {
    field: 'enabled',
    title: 'Enabled',
    render: (row, { onToggleEnabled, modeOff }) => (
      <Switch
        checked={row.is_active}
        onChange={() => onToggleEnabled(row)}
        size="small"
        color="primary"
        disabled={modeOff}
      />
    ),
  },
  {
    field: 'mode',
    title: 'Mode',
    disableStyle: true,
    render: (row) => get(row, 'mode', ''),
  },
  {
    field: 'name',
    title: 'Name',
    disableStyle: true,
    render: (row) => row.name,
  },
  {
    field: 'custom_name',
    title: 'Custom Name',
    disableStyle: true,
    render: (row) => row.custom_name || '',
  },
  {
    field: 'location_types',
    title: 'Location Type(s)',
    disableStyle: true,
    render: (row) => (row.location_types || []).map(uppercaseFirst).join(', '),
  },
  {
    field: 'edit_config',
    title: 'Edit Config',
    align: 'right',
    render: (row, { onConfigure, modeOff }) =>
      row.is_active && !modeOff ? (
        <Button color="primary" size="small" onClick={() => onConfigure(row)}>
          Configure
        </Button>
      ) : null,
  },
];

export default withRouter((props) => {
  const { isMobile } = useScreen();
  const { data, loading, updateTaskType, enabledModeIds } = useTaskTypes();

  const onToggleEnabled = (row) => {
    updateTaskType(row.id, { enabled: !row.is_active });
  };

  const onConfigure = (row) => {
    props.history.push(`/account/content/task-type/${row.id}`, { from: 'account/content' });
  };

  if (loading && !data.length) return <CenterLoader />;

  return (
    <TaskTypeContainer isMobile={isMobile}>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              {COLUMNS.map((col) => (
                <HeaderCell key={col.field} align={col.align}>
                  {col.title}
                </HeaderCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {(data || []).map((row) => {
              const modeOff = !enabledModeIds.includes(Number(row._appModeId));
              const disabled = !row.is_active || modeOff;
              const RowComp = disabled ? DisabledRow : EnabledRow;
              return (
                <RowComp key={row.id}>
                  {COLUMNS.map((col) => {
                    const content = col.render(row, { onConfigure, onToggleEnabled, modeOff });
                    const Cell = disabled && col.disableStyle ? DisabledTextCell : TableCell;
                    return (
                      <Cell key={col.field} align={col.align}>
                        {content}
                      </Cell>
                    );
                  })}
                </RowComp>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </TaskTypeContainer>
  );
});
